<template>
  <div>
    <PageAllow controller="StockOuts" action="sortingOutSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card class="my-5">
          <v-card-title>
            {{ $t("SortingOutSetting.objectName") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <!-- 启用分拣任务 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SortingOutSetting.sorting_task") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-checkbox
                  v-model="stock.sorting_task"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
              </v-col>
            </v-row>
            <!-- 显示扫码次数 -->
            <!-- <v-divider v-if="stock.sorting_task == 1" /> -->
            <v-row align="center" v-if="stock.sorting_task == 1">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("SortingOutSetting.sorting_scan_number_display") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-checkbox
                  v-model="stock.sorting_scan_number_display"
                  :true-value="1"
                  :false-value="0"
                ></v-checkbox>
              </v-col>
            </v-row>
            <!-- 分拣商品扫码类型 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("SortingOutSetting.sorting_material_barcode_setting") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col
                cols="9"
                md="7"
                v-if="stock.sorting_material_barcode_setting"
              >
                <v-radio-group
                  row
                  v-model="
                    stock.sorting_material_barcode_setting
                      .sorting_material_barcode_type
                  "
                >
                  <v-radio
                    :label="
                      $t('SortingOutSetting.sorting_material_barcode_type.one')
                    "
                    :key="1"
                    value="1"
                  />
                  <v-radio
                    :label="
                      $t('SortingOutSetting.sorting_material_barcode_type.two')
                    "
                    :key="2"
                    value="2"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row
              align="center"
              v-if="
                stock.sorting_material_barcode_setting &&
                stock.sorting_material_barcode_setting
                  .sorting_material_barcode_type == 1
              "
            >
              <v-col cols="2" class="font-weight-bold text-right"> </v-col>
              <v-col cols="10" v-if="stock.sorting_material_barcode_setting">
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t(
                        "SortingOutSetting.sorting_material_barcode_type.material_code"
                      ) + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" v-if="stock.sorting_material_barcode_setting">
                    <v-row>
                      <v-col cols="3">
                        <v-text-field
                          v-model="
                            stock.sorting_material_barcode_setting
                              .material_code_start
                          "
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                      </v-col>
                      <v-col cols="1" class="text-center">~</v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="
                            stock.sorting_material_barcode_setting
                              .material_code_end
                          "
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t(
                        "SortingOutSetting.sorting_material_barcode_type.weight_code"
                      ) + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" v-if="stock.sorting_material_barcode_setting">
                    <v-row>
                      <v-col cols="3">
                        <v-text-field
                          v-model="
                            stock.sorting_material_barcode_setting
                              .weight_code_start
                          "
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                      </v-col>
                      <v-col cols="1" class="text-center">~</v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="
                            stock.sorting_material_barcode_setting
                              .weight_code_end
                          "
                          single-line
                          dense
                          hide-details
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="my-5">
          <!-- 超级分拣员 -->
          <v-card-title>
            {{ $t("SortingOutSetting.super_sorting_users.name") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("SortingOutSetting.super_sorting_users.staff") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-btn color="primary" outlined @click="users_dialog = true">{{
                  $t("SortingOutSetting.super_sorting_users.choose")
                }}</v-btn>
                {{ $t("SortingOutSetting.super_sorting_users.hint") }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right"> </v-col>
              <v-col cols="9" md="7">
                <v-data-table
                  :headers="roleHeaders"
                  :items="stock.super_sorting_account_users"
                  :loading="loading"
                  multi-sort
                  class="elevation-1 px-4 pt-1"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:header.actions="{ header }">
                    {{ header.text }}
                    <v-icon x-small>fa-sliders-h</v-icon>
                  </template>
                  <!-- 删除操作 -->
                  <template v-slot:item.actions="{ item, index }">
                    <v-btn
                      small
                      text
                      class="danger--text pa-0"
                      @click.stop="
                        stock.super_sorting_account_users.splice(index, 1)
                      "
                    >
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="my-5" v-if="stock.sorting_task == 1">
          <v-card-title>
            {{ $t("SortingOutSetting.sorting_tasks.name") }}
            <v-spacer></v-spacer>
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'StockOuts',
                  'sortingTaskPositionImport'
                ) && stock.simple_wms_setting
              "
              small
              color="primary"
              class="ms-1"
              @click.stop="positionImportDialog = true"
            >
              <v-icon x-small class="pe-1">fa-file-import</v-icon>
              {{
                $t(
                  "SortingOutSetting.sorting_tasks.sorting_task_position_import"
                )
              }}
            </v-btn>
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'StockOuts',
                  'sortingTaskMaterialImport'
                )
              "
              small
              color="primary"
              class="ms-1"
              @click.stop="
                ImportDialog = true;
                currentTaskItem = {};
              "
            >
              <v-icon x-small class="pe-1">fa-file-import</v-icon>
              {{ $t("SortingOutSetting.sorting_tasks.importBTN") }}
            </v-btn>
            <v-btn
              small
              color="primary"
              class="ms-1"
              @click.stop="
                Add = true;
                currentTaskItem = {};
              "
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("SortingOutSetting.sorting_tasks.newTask") }}
            </v-btn>
          </v-card-title>
          <v-divider />
          <div class="mx-4 mb-4">
            <v-data-table
              item-key="id"
              :headers="taskHeaders"
              :items="sortingTasks"
              :loading="loading"
              multi-sort
              :search="filter"
              :expanded.sync="expanded"
              show-expand
              :footer-props="$t('$config.footer-props')"
              @item-expanded="loadDetails"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        sorting_tasks
                          ? [1, sorting_tasks.length, sorting_tasks.length]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-spacer />
                  <v-row no-gutters class="me-n3">
                    <v-spacer />
                    <v-col cols="12" sm="9" md="8">
                      <v-text-field
                        v-model="filter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:header.data-table-expand="{ header }">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  small
                  text
                  class="danger--text pa-0"
                  @click="
                    alertDialog = true;
                    currentItem = JSON.parse(JSON.stringify(item));
                  "
                >
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </template>
              <template v-slot:expanded-item="{ item }">
                <td colspan="2" class="theme--light">
                  <v-card-text class="mt-8 pb-12 theme--light">
                    <v-row
                      align="center"
                      v-if="
                        settings &&
                        settings.sorting_account_user_bind_material == 1
                      "
                    >
                      <!-- 绑定类型 -->
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("SortingOutSetting.sorting_tasks.bind_type") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="item.bind_type"
                          @change="changeBindType(item)"
                        >
                          <v-radio
                            :label="
                              $t(
                                'SortingOutSetting.sorting_tasks.category_type'
                              )
                            "
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="
                              $t(
                                'SortingOutSetting.sorting_tasks.material_type'
                              )
                            "
                            :key="2"
                            :value="2"
                          />
                          <v-radio
                            v-if="stock.simple_wms_setting"
                            :label="
                              $t(
                                'SortingOutSetting.sorting_tasks.position_type'
                              )
                            "
                            :key="3"
                            :value="3"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="item.bind_type == 1">
                      <!-- 商品分类 -->
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "SortingOutSetting.sorting_tasks.sorting_task_categories"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn
                          color="primary"
                          outlined
                          @click="
                            category_dialog = true;
                            currentItem = JSON.parse(JSON.stringify(item));
                          "
                          >{{
                            $t("CRUD.chooseInfo", [
                              $t(
                                "SortingOutSetting.sorting_tasks.sorting_task_categories"
                              ),
                            ])
                          }}</v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="item.bind_type == 1">
                      <v-col cols="3" class="font-weight-bold text-right">
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-data-table
                          :headers="categoryHeaders"
                          :items="item.sorting_task_categories"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-1"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <!-- 删除操作 -->
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="del(item, 'category')"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="item.bind_type == 2">
                      <!-- 选择商品 -->
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t(
                            "SortingOutSetting.sorting_tasks.sorting_task_materials"
                          ) + $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn
                          color="primary"
                          outlined
                          @click="
                            material_dialog = true;
                            currentItem = JSON.parse(JSON.stringify(item));
                          "
                          >{{
                            $t("CRUD.chooseInfo", [
                              $t(
                                "SortingOutSetting.sorting_tasks.sorting_task_materials"
                              ),
                            ])
                          }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="item.bind_type == 2">
                      <v-col cols="3" class="font-weight-bold text-right">
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-data-table
                          :headers="materialHeaders"
                          :items="item.sorting_task_materials"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-1"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <!-- 删除操作 -->
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="del(item, 'material')"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="item.bind_type == 3">
                      <!-- 绑定库位 -->
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("SortingOutSetting.sorting_tasks.position") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn
                          color="primary"
                          outlined
                          @click="
                            position_dialog = true;
                            currentItem = JSON.parse(JSON.stringify(item));
                          "
                          >{{
                            $t("CRUD.chooseInfo", [$t("Position.ObjectName")])
                          }}</v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="item.bind_type == 3">
                      <v-col cols="3" class="font-weight-bold text-right">
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-data-table
                          :headers="positionHeaders"
                          :items="item.sorting_task_positions"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-1"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <!-- 删除操作 -->
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="del(item, 'position')"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("SortingOutSetting.super_sorting_users.staff") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-btn
                          color="primary"
                          outlined
                          @click="
                            user_dialog = true;
                            currentItem = JSON.parse(JSON.stringify(item));
                          "
                          >{{
                            $t("SortingOutSetting.super_sorting_users.choose")
                          }}</v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-data-table
                          :headers="roleHeaders"
                          :items="item.account_user ? [item.account_user] : []"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-1"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <!-- 删除操作 -->
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="delUser(item)"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </td>
              </template>
              <template v-slot:item.name="{ item }">
                {{ item.name
                }}<v-icon
                  x-small
                  color="primary"
                  class="px-1 py-4 me-1"
                  @click.stop="
                    Add = true;
                    currentTaskItem = { id: item.id, name: item.name };
                  "
                  >fa-pencil-alt
                </v-icon>
              </template>
            </v-data-table>
          </div>
          <!-- </v-card-text> -->
        </v-card>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn color="success" block @click="save()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    <!-- 新增任务 -->
    <v-dialog v-model="Add" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("SortingOutSetting.sorting_tasks.info") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Add = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 subtitle-1">
          <ValidationObserver ref="taskObserver">
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("SortingOutSetting.sorting_tasks.taskName")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('SortingOutSetting.sorting_tasks.taskName')"
                >
                  <v-text-field
                    v-model="currentTaskItem.name"
                    dense
                    :error-messages="errors"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="Add = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="SubmitTask()">
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogCategories
      v-model="category_dialog"
      :categorySelected="currentItem ? currentItem.sorting_task_categories : []"
      @confirm="addCategory = $event"
    />
    <MaterialsSelectsDialog
      v-model="material_dialog"
      :materialIds="
        currentItem
          ? currentItem.sorting_task_materials
            ? currentItem.sorting_task_materials.map((m) => m.id)
            : []
          : []
      "
      @confirm="addMaterial = $event"
    />
    <DialogPositions
      v-model="position_dialog"
      :positionSelected="currentItem ? currentItem.sorting_task_positions : []"
      @confirm="addPosition = $event"
      :stockId="stock.id"
    />
    <DialogAccountUsers
      v-model="users_dialog"
      :changed="
        stock.super_sorting_account_users
          ? stock.super_sorting_account_users
          : []
      "
      @confirm="addSuperUsers = $event"
      :usersIdDisabled="superUserDisabledArr"
    />
    <DialogAccountUser
      v-model="user_dialog"
      :userChoosed="
        currentItem && currentItem.account_user
          ? [currentItem.account_user]
          : []
      "
      @confirm="addUser = $event"
      :usersIdDisabled="userDisabledArr"
    />

    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('SortingOutSetting.sorting_tasks.importTitle')"
      downloadFromAPI
      @download="importTemplateExport()"
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportExcelAlert
      v-model="positionImportDialog"
      :objName="$t('SortingOutSetting.sorting_tasks.sorting_task_position')"
      downloadFromAPI
      @download="positionExport()"
      @import="
        positionExcelFile = $event;
        positionImport();
      "
    />
    <ImportMaterialsResult
      v-model="importResultFlg"
      :items="importResult"
      v-on:close="
        importResultFlg = false;
        getSortingOutSettingFromAPI();
      "
    />

    <DialogAlert
      v-model="alertDialog"
      :message="$t('SortingOutSetting.sorting_tasks.del_task_msg', [currentItem ? currentItem.name : ''])"
      useConfirm
      @confirm="delTask(currentItem)"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockOuts from "@/api/stock_outs";
import SortingTasks from "@/api/sorting_tasks";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import DialogCategories from "@/components/plugins/DialogCategories";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import MaterialsSelectsDialog from "./plugins/MaterialsSelectsDialog";
import DialogAccountUsers from "./plugins/DialogAccountUsers";
import DialogAccountUser from "./plugins/DialogAccountUser";
import ImportMaterialsResult from "./plugins/ImportMaterialsResult";
import DialogPositions from "@/components/plugins/DialogPositions";
import DialogAlert from "@/components/plugins/DialogAlert.vue";

export default {
  components: {
    DialogAlert,
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
    DialogCategories,
    DialogAccountUsers,
    DialogAccountUser,
    MaterialsSelectsDialog,
    ImportExcelAlert,
    ImportMaterialsResult,
    DialogPositions,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Stock.actions.waveSortSetting"),
        disabled: true,
        href: "",
      },
    ],
    roleHeaders: () => [
      {
        text: i18n.t("SortingOutSetting.super_sorting_users.staff_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("SortingOutSetting.super_sorting_users.del"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    taskHeaders: () => [
      {
        text: i18n.t("SortingOutSetting.sorting_tasks.tasks"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("SortingOutSetting.sorting_tasks.actions"),
        align: "start",
        sortable: false,
        value: "data-table-expand",
        width: "100px",
      },
      {
        text: "",
        align: "start",
        sortable: false,
        value: "actions",
        width: "20px",
      },
    ],
    categoryHeaders: () => [
      {
        text: i18n.t("SortingOutSetting.sorting_tasks.category_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("SortingOutSetting.super_sorting_users.del"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    positionHeaders: () => [
      {
        text: i18n.t("SortingOutSetting.sorting_tasks.position_name"),
        align: "start",
        sortable: false,
        value: "position_name",
      },
      {
        text: i18n.t("SortingOutSetting.super_sorting_users.del"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    materialHeaders: () => [
      {
        text: i18n.t("SortingOutSetting.sorting_tasks.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("SortingOutSetting.super_sorting_users.del"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    sortingTasks() {
      var tasks = [];
      if (this.sorting_tasks && this.sorting_tasks.length) {
        tasks = this.sorting_tasks.map((task) => {
          // 商品分类获取任务id
          if (task.sorting_task_categories) {
            task.sorting_task_categories.forEach((category) => {
              category.task_id = task.id;
            });
          }
          if (task.sorting_task_materials) {
            task.sorting_task_materials.forEach((material) => {
              material.task_id = task.id;
            });
          }
          if (task.sorting_task_positions) {
            task.sorting_task_positions.forEach((position) => {
              position.task_id = task.id;
            });
          }

          // 员工获取任务id
          if (task.account_user) {
            task.account_user.task_id = task.id;
            // Object.assign({}, task.account_user, { task_id: task.id });
          }
          return task;
        });
      }
      return tasks;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    stock: {},
    sorting_tasks: [],
    expanded: [],
    Add: false,
    currentTaskItem: {},
    filter: "",
    category_dialog: false,
    material_dialog: false,
    addCategory: [],
    addMaterial: [],
    addPosition: [],
    currentItem: null,
    users_dialog: false,
    addSuperUsers: [],
    addUser: {},
    user_dialog: false,
    userDisabledArr: [],
    superUserDisabledArr: [],
    ImportDialog: false,
    excelFile: null,
    importResultFlg: false,
    importResult: [],
    // categoriesDisabledArr: [],
    // materialsDisabledArr: [],
    positionImportDialog: false,
    positionExcelFile: null,
    position_dialog: false,
    alertDialog: false,
  }),

  mounted() {
    this.getSortingOutSettingFromAPI();
  },

  methods: {
    getSortingOutSettingFromAPI() {
      StockOuts.fetchSortingOutSetting(this.$route.query.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
            this.sorting_tasks = response.data.sorting_tasks;
            if (this.stock.sorting_material_barcode_setting == null) {
              //分拣商品扫码类型
              this.stock.sorting_material_barcode_setting = {
                sorting_material_barcode_type: "1",
                material_code_start: 1,
                material_code_end: 4,
                weight_code_start: 5,
                weight_code_end: 10,
              };
            }
          }
        }.bind(this)
      );
    },

    loadDetails({ item, value }) {
      if (value) {
        this.$store.dispatch("fullscreenLoading");
        StockOuts.getSortingTask({
          stock_id: this.$route.query.stock_id,
          sorting_task_id: item.id,
        })
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                let sorting_task = response.data.sorting_task;
                this.sorting_tasks = this.sorting_tasks.map((task) => {
                  if (task.id == sorting_task.id) {
                    task = Object.assign({}, task, sorting_task);
                  }
                  return task;
                });
                this.$store.dispatch("fullscreenLoadingStop");
              }
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },

    freshDetails(sorting_task_id) {
      this.$store.dispatch("fullscreenLoading");
      StockOuts.getSortingTask({
        stock_id: this.$route.query.stock_id,
        sorting_task_id: sorting_task_id,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              let sorting_task = response.data.sorting_task;
              this.sorting_tasks = this.sorting_tasks.map((task) => {
                if (task.id == sorting_task.id) {
                  task = Object.assign({}, task, sorting_task);
                }
                return task;
              });
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },

    save() {
      var data = {};
      var stock = {
        id: this.stock.id,
        sorting_task: this.stock.sorting_task,
        sorting_scan_number_display: this.stock.sorting_scan_number_display,
        super_sorting_users:
          this.stock.super_sorting_account_users &&
          this.stock.super_sorting_account_users.length
            ? this.stock.super_sorting_account_users.map((m) => m.id)
            : [],
        sorting_material_barcode_setting: {
          sorting_material_barcode_type:
            this.stock.sorting_material_barcode_setting
              .sorting_material_barcode_type,
          material_code_start:
            this.stock.sorting_material_barcode_setting.material_code_start,
          material_code_end:
            this.stock.sorting_material_barcode_setting.material_code_end,
          weight_code_start:
            this.stock.sorting_material_barcode_setting.weight_code_start,
          weight_code_end:
            this.stock.sorting_material_barcode_setting.weight_code_end,
        },
      };
      var task_edit = [];
      task_edit = this.sorting_tasks
        ? this.sorting_tasks.map((task) => {
            return {
              task_id: task.id,
              account_user_id: task.account_user ? task.account_user.id : null,
              bind_type: task.bind_type ? task.bind_type : 1,
              category_codes:
                task.bind_type == 1
                  ? task.newAddCategory
                    ? task.newAddCategory
                    : []
                  : [],
              material_ids:
                task.bind_type == 2
                  ? task.newAddMaterial
                    ? task.newAddMaterial
                    : []
                  : [],
              position_ids:
                task.bind_type == 3
                  ? task.newAddPosition
                    ? task.newAddPosition
                    : []
                  : [],
            };
          })
        : [];
      data = Object.assign({}, data, { stock, task_edit });
      StockOuts.saveSortingOutSetting(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("logisticsApiSetting.saveSuccess"));
            this.newAddCategory = [];
            this.newAddMaterial = [];
            this.newAddPosition = [];
          }
        }.bind(this)
      );
    },
    SubmitTask() {
      this.$refs.taskObserver.validate().then(
        function (result) {
          if (result) {
            if (this.currentTaskItem.id) {
              SortingTasks.edit({
                id: this.currentTaskItem.id,
                name: this.currentTaskItem.name,
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.Add = false;
                    this.getSortingOutSettingFromAPI();
                  }
                }.bind(this)
              );
            } else {
              SortingTasks.add({
                stock_id: this.$route.query.stock_id,
                name: this.currentTaskItem.name,
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.Add = false;
                    this.getSortingOutSettingFromAPI();
                  }
                }.bind(this)
              );
            }
          }
        }.bind(this)
      );
    },
    del(data, type) {
      // 删除分类
      this.sorting_tasks.forEach((task) => {
        if (task.id == data.task_id) {
          if (type == "category") {
            if (
              task.newAddCategory &&
              task.newAddCategory.findIndex(
                (categoryCode) => data.code == categoryCode
              ) > -1
            ) {
              task.sorting_task_categories.forEach((category, index) => {
                if (category.id == data.id) {
                  task.sorting_task_categories.splice(index, 1);
                }
              });
              task.newAddCategory.splice(
                task.newAddCategory.findIndex(
                  (categoryId) => data.id == categoryId
                ),
                1
              );
            } else {
              StockOuts.removeCategory(data.task_id, {
                remove_category_codes: [data.code],
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.freshDetails(data.task_id);
                  }
                }.bind(this)
              );
            }
          }
          if (type == "material") {
            if (
              task.newAddMaterial &&
              task.newAddMaterial.findIndex(
                (materialId) => data.id == materialId
              ) > -1
            ) {
              task.sorting_task_materials.forEach((material, index) => {
                if (material.id == data.id) {
                  task.sorting_task_materials.splice(index, 1);
                }
              });
              task.newAddMaterial.splice(
                task.newAddMaterial.findIndex(
                  (materialId) => data.id == materialId
                ),
                1
              );
            } else {
              StockOuts.removeMaterial(data.task_id, {
                remove_material_ids: [data.id],
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.freshDetails(data.task_id);
                  }
                }.bind(this)
              );
            }
          }
          if (type == "position") {
            if (
              task.newAddPosition &&
              task.newAddPosition.findIndex(
                (positionId) => data.id == positionId
              ) > -1
            ) {
              task.sorting_task_positions.forEach((position, index) => {
                if (position.id == data.id) {
                  task.sorting_task_positions.splice(index, 1);
                }
              });
              task.newAddPosition.splice(
                task.newAddPosition.findIndex(
                  (positionId) => data.id == positionId
                ),
                1
              );
            } else {
              StockOuts.removePosition(data.task_id, {
                remove_position_ids: [data.id],
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.freshDetails(data.task_id);
                  }
                }.bind(this)
              );
            }
          }
        }
      });
    },
    delUser(data) {
      // 删除员工
      this.sorting_tasks = this.sorting_tasks.map((task) => {
        if (task.id == data.task_id) {
          task = Object.assign({}, task, { account_user: null });
        }
        return task;
      });
    },
    changeBindType(data) {
      // 删除分类
      this.sorting_tasks = this.sorting_tasks.map((task) => {
        if (task.id == data.id) {
          task.sorting_task_categories = [];
          task.sorting_task_materials = [];
          task.sorting_task_positions = [];
          task.newAddPosition = [];
          task.newAddMaterial = [];
          task.newAddCategory = [];
        }
        return task;
      });
    },
    importTemplateExport() {
      SortingTasks.materialExport({ stock_id: this.stock.id });
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      SortingTasks.materialImport(this.stock.id, this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.ImportDialog = false;
                this.importResultFlg = true;
                this.importResult = response.data.data;
              } else {
                this.ImportDialog = false;
                this.$snackbar.info(
                  i18n.t("Import.success", [
                    i18n.t("SortingOutSetting.sorting_tasks.importTitle"),
                  ])
                );
                this.getSortingOutSettingFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    positionExport() {
      SortingTasks.positionExport({ stock_id: this.stock.id });
    },
    positionImport() {
      this.$store.dispatch("fullscreenLoading");
      SortingTasks.positionImport(this.stock.id, this.positionExcelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.positionImportDialog = false;
              this.$snackbar.info(
                i18n.t("Import.success", [
                  i18n.t(
                    "SortingOutSetting.sorting_tasks.sorting_task_position"
                  ),
                ])
              );
              this.getSortingOutSettingFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    delTask(data) {
      SortingTasks.delTask(data.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.alertDialog = false;
              this.getSortingOutSettingFromAPI();
            }
          }.bind(this)
      );
    },
  },

  watch: {
    Add: {
      handler() {
        if (!this.Add) {
          this.$refs.taskObserver.reset();
        }
      },
    },
    addCategory: {
      handler() {
        if (this.addCategory.length) {
          var index = this.sorting_tasks.findIndex(
            (task) => task.id == this.currentItem.id
          );
          this.addCategory.forEach((item) => {
            if (
              !this.currentItem.sorting_task_categories.length ||
              this.currentItem.sorting_task_categories.findIndex(
                (category) => category.code == item.code
              ) == -1
            ) {
              if (!this.currentItem.newAddCategory) {
                this.currentItem.newAddCategory = [];
              }
              this.currentItem.newAddCategory.push(item.code);
            }
          });
          this.currentItem.sorting_task_categories = this.addCategory;
          this.sorting_tasks.splice(index, 1, this.currentItem);
        }
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial.length) {
          var index = this.sorting_tasks.findIndex(
            (task) => task.id == this.currentItem.id
          );
          this.addMaterial.forEach((material) => {
            this.currentItem.sorting_task_materials.push(material);
            if (!this.currentItem.newAddMaterial) {
              this.currentItem.newAddMaterial = [];
            }
            this.currentItem.newAddMaterial.push(material.id);
          });
          this.sorting_tasks.splice(index, 1, this.currentItem);
        }
      },
    },
    addPosition: {
      handler() {
        if (this.addPosition.length) {
          var index = this.sorting_tasks.findIndex(
            (task) => task.id == this.currentItem.id
          );
          this.addPosition.forEach((item) => {
            if (
              !this.currentItem.sorting_task_positions.length ||
              this.currentItem.sorting_task_positions.findIndex(
                (position) => position.id == item.id
              ) == -1
            ) {
              if (!this.currentItem.newAddPosition) {
                this.currentItem.newAddPosition = [];
              }
              this.currentItem.newAddPosition.push(item.id);
            }
          });
          this.currentItem.sorting_task_positions = this.addPosition;
          this.sorting_tasks.splice(index, 1, this.currentItem);
        }
      },
    },

    addSuperUsers: {
      handler() {
        this.stock.super_sorting_account_users = this.addSuperUsers;
      },
    },
    addUser: {
      handler() {
        var index = this.sorting_tasks.findIndex(
          (task) => task.id == this.currentItem.id
        );
        this.currentItem.account_user = this.addUser;
        this.sorting_tasks.splice(index, 1, this.currentItem);
      },
    },
    //  分拣任务员工
    user_dialog: {
      handler() {
        if (this.user_dialog) {
          var ids = [];
          if (
            this.stock.super_sorting_account_users &&
            this.stock.super_sorting_account_users.length
          ) {
            this.stock.super_sorting_account_users.forEach((d) => {
              ids.push(d.id);
            });
          }
          if (this.currentItem) {
            this.sorting_tasks.forEach((d) => {
              if (d.account_user) {
                if (this.currentItem.account_user) {
                  if (d.account_user.id != this.currentItem.account_user.id) {
                    ids.push(d.account_user.id);
                  }
                } else {
                  ids.push(d.account_user.id);
                }
              }
            });
          }
          this.userDisabledArr = ids;
        }
      },
    },
    // category_dialog: {
    //   handler() {
    //     if (this.category_dialog) {
    //       var categoriesids = [];
    //       if (this.currentItem) {
    //         this.sorting_tasks.forEach((d) => {
    //           // 分类不重复
    //           if (d.id != this.currentItem.id) {
    //             if (d.sorting_task_categories.length) {
    //               d.sorting_task_categories.forEach((c) => {
    //                 categoriesids.push(c.id);
    //               });
    //             }
    //           }
    //         });
    //       }
    //       this.categoriesDisabledArr = categoriesids;
    //     }
    //   },
    // },
    // material_dialog: {
    //   handler() {
    //     if (this.material_dialog) {
    //       let materials = [];
    //       if (this.currentItem) {
    //         this.sorting_tasks.forEach((d) => {
    //           // 分类不重复
    //           if (d.id != this.currentItem.id) {
    //             if (d.sorting_task_materials.length) {
    //               d.sorting_task_materials.forEach((c) => {
    //                 materials.push(c.id);
    //               });
    //             }
    //           }
    //         });
    //       }
    //       this.materialsDisabledArr = materials;
    //     }
    //   }
    // },
    // 超级分拣员弹窗
    users_dialog: {
      handler() {
        if (this.users_dialog) {
          if (this.sorting_tasks.length) {
            var ids = [];
            this.sorting_tasks.forEach((d) => {
              if (d.account_user) {
                if (ids.indexOf(d.account_user.id) == -1) {
                  ids.push(d.account_user.id);
                }
              }
            });
            this.superUserDisabledArr = ids;
          } else {
            this.superUserDisabledArr = [];
          }
        }
      },
    },
  },
};
</script>